<div class="modal-header">
  <h4 class="modal-title text-center">{{ title }}</h4>
  <img class="modal-close" (click)="dismissModal()" alt="Dismiss modal">
</div>
<div class="modal-body">
  <div class="container">
    <div class="vehicle-desc">{{ results.make }} {{ results.model }}</div>
    <img [src]="results.imageUrl" />
    <div class="row">
        <div class="col-7 results-cell right">Number of attempts:</div>
        <div class="col-5 results-cell">{{ results.attempts }}</div>
        <div class="col-7 results-cell right">Points awarded:</div>
        <div class="col-5 results-cell">{{ results.points }}</div>
    </div>
    <div class="button-box">
        <button class="ok-button button_green" (click)="close()" ngbAutofocus>Ok</button>
    </div>
  </div>
</div>